import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output, Inject } from '@angular/core';
import { GestureEvent } from '../gesture-event.interface';
import { GestureAdapter } from '../gesture-adapter.interface';
import { GESTURE_ADAPTER } from '../gesture.tokens';

@Directive({
  selector: '[panGesture]',
  standalone: false,
})
export class PanGestureDirective implements OnInit, OnDestroy {
  @Output() panStart = new EventEmitter<GestureEvent>();
  @Output() panMove = new EventEmitter<GestureEvent>();
  @Output() panEnd = new EventEmitter<GestureEvent>();

  private cleanup?: () => void;

  constructor(private el: ElementRef, @Inject(GESTURE_ADAPTER) private adapter: GestureAdapter) {}

  ngOnInit(): void {
    this.cleanup = this.adapter.bindPan(this.el, {
      start: (e) => this.panStart.emit(e),
      move: (e) => this.panMove.emit(e),
      end: (e) => this.panEnd.emit(e),
    });
  }

  ngOnDestroy(): void {
    this.cleanup?.();
  }
}
